import { GetForgotPasswordConfirmationCodeArgs } from 'types/api/arguments/get-forgot-password-confirmation-code-args'
import { GetForgotPasswordConfirmationCodeResp } from 'types/api/response/get-forgot-password-confirmation-code-resp'

import { api } from './api'

export const getForgotPasswordConfirmationCode = ({
  code,
}: GetForgotPasswordConfirmationCodeArgs) =>
  api.get<GetForgotPasswordConfirmationCodeResp>('/users/forgot_password', {
    params: { code },
  })
